wbApp.controller('RentTabsItemsCtrl', ['$scope', '$modal', '$translate',
function ($scope, $modal, $translate) {

    var selectedRent = null;

    $scope.rentItems = [];

    $scope.$on('rentSelectionChanged', function (e, newlySelectedRent) {
        selectedRent = newlySelectedRent;

        $scope.rentItems.length = 0;
        if (!!selectedRent) {
            $scope.rentItems.push.apply($scope.rentItems, selectedRent.rentedItems);
        }
    });


    $scope.rentItemsGridSettings = {
        name: 'rentItems',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            {
                dataField: 'externalId',
                caption: $translate.instant('TXT_EXTERNAL_ID'),
                dataType: 'string',
                width: '140px',
                sortOrder: 'asc'
            },
            {
                dataField: 'rentItemName',
                caption: $translate.instant('TXT_NAME'),
                dataType: 'string'
            },
            {
                dataField: 'rentCategoryName',
                caption: $translate.instant('TXT_MENU_RENT_CATEGORIES'),
                dataType: 'date',
                dataType: 'string',
                width: '160px'
            },
            {
                dataField: 'itemTypeName',
                caption: $translate.instant('TXT_MENU_ITEM_TYPE'),
                dataType: 'date',
                dataType: 'string',
                width: '160px'
            },
            {
                dataField: 'itemCondition',
                caption: $translate.instant('TXT_MENU_ITEM_CONDITION'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_READY_FOR_RENTING') },
                                { id: 1, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_BROKEN') },
                                { id: 2, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_MAINTENANCE') },
                                { id: 3, name: $translate.instant('TXT_ITEM_CONDITION_TYPE_DECOMMISSIONED') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '200px'
            }
        ]
    }

}]);
